<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <span class="leftLine"></span>
      <el-breadcrumb-item>客户电量申报管理</el-breadcrumb-item>
      <el-breadcrumb-item>查看申报</el-breadcrumb-item>
      <el-button type="primay"
                 style="float:right;margin:6px 60px"
                 @click="$router.back()">返回</el-button>
    </el-breadcrumb>
    <div style="padding:20px;background:rgb(249,249,249)">
      <el-row>
        <el-col :span="24">
          <p class="title">{{name}}</p>
        </el-col>
      </el-row>
      <div style="margin-top:20px">
        <div style="background-color: rgba(243, 243, 243, 1);padding-top:20px">
          <el-row style="padding:0 20px">
            <el-col :span="12">
              <p class="text"><i class="el-icon-s-operation"></i>申报记录</p>
            </el-col>
            <el-col :span="12"
                    style="justify-content: flex-end;display:flex">
              <!-- <el-upload class="upload-demo"
                         action
                         :show-file-list="false"
                         :http-request="uploadfile">
                <el-button size="mimi"
                           type="primary">导入</el-button>
              </el-upload>
              <el-button type="primary"
                         style="margin-left:20px"
                         size="mini"><a @click="exportMethod('https://c.cesc-energy.com/service/declare/export')"
                   style="color:#fff">导出</a></el-button> -->
              <el-button type="primary"
                         @click="add"
                         size="mini">添加</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-row style="margin-top:20px">
              <el-table border
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                <el-table-column type="selection">
                </el-table-column>
                <el-table-column label="账号">
                  <template slot-scope="scope">{{ scope.row.userAccount}}</template>
                </el-table-column>

                <el-table-column prop="userName"
                                 label="用户名">
                </el-table-column>
                <el-table-column prop="declaretime"
                                 sortable
                                 label="电量申报日期">
                </el-table-column>
                <el-table-column prop="electrotimeStart"
                                 label="用电日期">
                </el-table-column>
                <el-table-column prop="electro"
                                 sortable
                                 width="170"
                                 label="申报电量(万千瓦时)">
                </el-table-column>
                <el-table-column prop="days"
                                 label="当月正常生产天数">
                </el-table-column>
                <el-table-column prop="lastmonth"
                                 label="跟上月同比">
                </el-table-column>
                <el-table-column prop="lastyear"
                                 label="跟去年相同月同比">
                </el-table-column>
                <el-table-column prop="explainNote"
                                 label="企业补充说明">
                </el-table-column>
                <el-table-column prop="status"
                                 label="状态"
                                 width="100">
                  <template slot-scope="scope">
                    <span v-show="scope.row.status==1">已申报</span>
                    <span v-show="scope.row.status==2">申报中</span>
                    <span v-show="scope.row.status==3">未开始</span>
                  </template>
                </el-table-column>
                <el-table-column prop="address"
                                 label="操作"
                                 width="200"
                                 show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-button @click="check1(scope.row.declareId)"
                               type="text"
                               size="small">编辑</el-button>
                    <el-button type="text"
                               size="small"
                               @click="deleteTable(scope.$index, tableData,scope.row.declareId)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>

            </el-row>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getdeclare, deletedeclare, postdeclareFile } from '../../API'
import exportMethod from '../../util/util'
export default {
  data () {
    return {
      total: 0,
      current: 1,
      formInline: {},
      form: {},
      tableData: [],
      value: '',
      checked: false,
      multipleSelection: [],
      name: localStorage.getItem('clientName')
    }
  },
  created () {
    if (localStorage.getItem('clientName')) {
      getdeclare(localStorage.getItem('clientName')).then(res => {
        if (res.code == 0) {
          this.total = res.data.total;
          this.current = res.data.current;
          this.tableData = res.data
        }
      })
    }

  },
  methods: {
    exportMethod,
    uploadfile (item) {
      let fileObj = item.file
      let name = fileObj.name;
      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(name)) {
        this.$notify.error({
          title: "错误",
          message: "上传文件只能为excel文件，且为xlsx,xls格式",
        });
        return false;
      }
      const form = new FormData()// FormData 对象
      form.append('file', fileObj)// 文件对象  'upload'是后台接收的参数名
      postdeclareFile(form).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
        }
      })
    },
    handleCurrentChange (val) {
      this.current = val
      this.onSubmit()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    check1 (id) {
      localStorage.setItem('declareId', id)
      this.$router.push({ path: '/jyzx/cksbbj', query: { text: '新增' } })
    },
    check (id) {
      localStorage.setItem('declareId', id)
      this.$router.push({ path: '/jyzx/cksb' })
    },
    add () {
      localStorage.removeItem('declareId')
      this.$router.push({ path: '/jyzx/cksbbj' })
    },
    toggleAllSelection () {
      this.$refs.multipleTable.toggleAllSelection()
    },
    deleteTable (index, rows, id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rows.splice(index, 1);
        deletedeclare(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            getdeclare().then(res => {
              if (res.code === 0) {
                this.total = res.data.total;
                this.current = res.data.current;
                this.tableData = res.data.records
              }
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteTables () {
      let params = []
      for (let i = 0; i < this.multipleSelection.length; i++) {
        params.push(this.multipleSelection[i].id)
      }
      postsclare(status, params).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '成功',
            type: 'success'
          });
          getdeclare().then(res => {
            if (res.code === 0) {
              this.total = res.data.total;
              this.current = res.data.current;
              this.tableData = res.data.records
            }
          })
        }
      })
    },
    onSubmit () {
      let params = this.formInline
      params.current = this.current
      getdeclare(params).then(res => {
        if (res.code === 0) {
          this.total = res.data.total;
          this.current = res.data.current;
          this.tableData = res.data.records
        }
      })
    },
  }

}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
}
.title {
  font-weight: 650;
  font-style: normal;
  font-size: 24px;
  color: #3498db;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}
.el-main {
  background-color: rgba(249, 249, 249, 1);
  padding: 0;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}
</style>